import * as Sentry from '@sentry/vue'
import { config } from '@/lib/helpers'

export const ErrorHandler = {
  install: (app) => {
    window.onerror = function (event, source, line, column) {
      if (config.environment === 'production') {
        Sentry.captureException(
          new Error(
            `Event: ${typeof event === 'string' ? event : JSON.stringify(event)}, Source: ${source}. Line: ${line}. Column: ${column}`,
          ),
        )
      }
    }

    app.config.errorHandler = (err) => {
      Sentry.captureException(err)
      if (config.environment === 'local') throw err
    }
  },
}
